/*
  1) Guards are executed serially in the order they are supplied.

  2) Guard execution will stop when all passed guards are
  executed OR when any guard calls next() with an argument other than undefined.

  3) When a guard calls next() with an argument other than undefined, that argument will be passed to VueRouter.
*/

function isUndefined(value) {
  return value === undefined;
}

function evaluateGuards(guards, to, from, next) {
  const guardsLeft = guards.slice(0); // clone the array so we do not accidentally modify it
  const nextGuard = guardsLeft.shift();

  if (isUndefined(nextGuard)) {
    next();
    return;
  }

  nextGuard(to, from, (nextArg) => {
    if (isUndefined(nextArg)) {
      evaluateGuards(guardsLeft, to, from, next);
      return;
    }

    next(nextArg);
  });
}

export default function multiguard(guards) {
  if (!Array.isArray(guards)) {
    throw new Error('You must specify an array of guards');
  }

  return (to, from, next) => evaluateGuards(guards, to, from, next);
}
